/**
 * Utility functions for managing return URLs during authentication flows
 * Enables deep linking by preserving the user's location before logout
 */

import { getBasePath } from '../utils/routing.utils';

const RETURN_URL_KEY = 'auth_return_url';

/**
 * Store the current URL path to return to after re-authentication
 * @param path - Optional path to store. If not provided, uses current location
 */
export const storeReturnUrl = (path?: string): void => {
  try {
    const returnPath = path || window.location.pathname + window.location.search + window.location.hash;
    
    // Strip the basename if it exists (for React Router basename compatibility)
    const basePath = getBasePath();
    let relativeReturnPath = returnPath;
    
    if (basePath && returnPath.startsWith(basePath)) {
      relativeReturnPath = returnPath.slice(basePath.length) || '/';
    }
    
    // Only store non-root paths to avoid unnecessary redirects
    if (relativeReturnPath && relativeReturnPath !== '/' && relativeReturnPath !== '') {
      sessionStorage.setItem(RETURN_URL_KEY, relativeReturnPath);
      console.log('[ReturnURL] Stored return URL:', relativeReturnPath, '(original:', returnPath, ', basePath:', basePath, ')');
    }
  } catch (error) {
    console.error('[ReturnURL] Failed to store return URL:', error);
  }
};

/**
 * Retrieve the stored return URL
 * @returns The stored path or null if none exists
 */
export const getReturnUrl = (): string | null => {
  try {
    const returnUrl = sessionStorage.getItem(RETURN_URL_KEY);
    console.log('[ReturnURL] Retrieved return URL:', returnUrl);
    return returnUrl;
  } catch (error) {
    console.error('[ReturnURL] Failed to retrieve return URL:', error);
    return null;
  }
};

/**
 * Clear the stored return URL
 */
export const clearReturnUrl = (): void => {
  try {
    sessionStorage.removeItem(RETURN_URL_KEY);
    console.log('[ReturnURL] Cleared return URL');
  } catch (error) {
    console.error('[ReturnURL] Failed to clear return URL:', error);
  }
};
